import { UserModel } from "@/types/User";
import { fetcher, baseBFF } from "./_utils";
import { useEffect } from "react";
import { signOut, useSession } from "next-auth/react";
import useSWRMutation from "swr/mutation";
import datadog from "@ilg-core/analytics/datadog";

export const useUser = (): {
  trigger: () => any;
  userDetails: UserModel;
  userDetailsIsLoading: boolean;
  userDetailsIsError: boolean;
} => {
  const token = useToken();
  const { trigger, data, error, isMutating } = useSWRMutation(
    token ? [`/${baseBFF()}/menu/customer-details`, token] : null,
    ([url, token]) => fetcher(url, token)
  );

  return {
    trigger: trigger,
    userDetails: data,
    userDetailsIsLoading: token ? isMutating : true,
    userDetailsIsError: error,
  };
};

export function useToken() {
  const { data: session, update } = useSession({ required: true });
  useEffect(() => {
    if (!session?.accessToken) {
      // if accessToken not found revalidate the session
      update();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return session?.accessToken;
}

// Session cleanup on logout
export const onLogout = async (idToken?: string, redirect: boolean = true) => {
  idToken && sessionStorage.setItem("idToken", JSON.stringify(idToken));
  datadog.log.info('User requested sign out', { redirect });
  await signOut({ callbackUrl: "/auth/signout-flow", redirect: redirect });
};